import { Select } from "@nulogy/components";
import useGetCustomers from "hooks/apollo/customer/useGetCustomers";
import memoizeOne from "memoize-one";
import React from "react";
import FilterLabel from "./FilterLabel";

const memoizedCustomers = memoizeOne(buildCustomerOptions);

function buildCustomerOptions(customers) {
  return customers.map((customer) => ({
    label: customer,
    value: customer,
  }));
}

export default function CustomerSelector({ onChange, selectedCustomers }) {
  const { data, loading } = useGetCustomers();

  if (loading) return null;

  const customers = data?.customers || [];

  const customerFilterOptions = memoizedCustomers(customers);

  return (
    <>
      <FilterLabel value="Customer" />
      <Select
        className="spec-customers-filter-multiselect"
        closeMenuOnSelect={false}
        maxHeight="250"
        multiselect
        onChange={onChange}
        options={customerFilterOptions}
        placeholder="Select..."
        value={selectedCustomers}
      />
    </>
  );
}
